import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarComponent } from './progressBar.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [
        ProgressBarComponent
    ],
    exports: [
		ProgressBarComponent
    ],
    providers: [],
    entryComponents: [
        ProgressBarComponent
    ]
})
export class ProgressBarModule {
}
